// Firestore Timestamps, JS Dates, plain `{seconds, nanoseconds}`-shaped
// objects (e.g. from a REST/cache layer that isn't a real Timestamp
// instance), and "YYYY-MM-DD" strings all show up as date values across
// this codebase depending on where they were read from — this normalizes
// any of them to a JS Date (or null if unparseable).
export function toDateValue(value) {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'object') {
    const seconds =
      typeof value._seconds === 'number'
        ? value._seconds
        : typeof value.seconds === 'number'
          ? value.seconds
          : null;
    if (seconds != null) {
      const nanos =
        typeof value._nanoseconds === 'number'
          ? value._nanoseconds
          : typeof value.nanoseconds === 'number'
            ? value.nanoseconds
            : 0;
      const millis = seconds * 1000 + Math.floor(nanos / 1000000);
      const parsed = new Date(millis);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
  }
  if (typeof value === 'string') {
    const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
}
